module.exports = __webpack_public_path__ + "static/media/021ty@2x.1c3945e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/021ty@2x.png
// module id = 1671
// module chunks = 0 1